import React from 'react';
import SignOutButton from "../SignOut"
import StButton from "../misc/button";

import * as ROUTES from '../../constants/routes';
import { withAuthentication } from '../Session';


const Navigation = (authUser) => {
 return authUser.firebase.auth.currentUser != null ? <NavigationAuth /> : <NavigationNonAuth />
};

const NavigationAuth = () => (
  <div style={{padding: "20px"}}>
    <SignOutButton />
  </div>
);

const NavigationNonAuth = () => (
  <div></div>
);
/*
no "Sign In" required if not logged in - there is no other option to go to
  <div style={{padding: "20px"}}>
    <StButton href={ROUTES.SIGN_IN} text="Sign In" />
  </div>
);
*/

export default withAuthentication(Navigation);